import { createFileRoute, Outlet } from '@tanstack/react-router';
import OutlookLayout from 'src/features/plugins/outlook/layout';

export const Route = createFileRoute('/plugins/outlook')({
  component: () => (
    <OutlookLayout>
      <Outlet />
    </OutlookLayout>
  ),
});
